import { render, staticRenderFns } from "./AddProfilesAdminModal.vue?vue&type=template&id=7b86b0f4&scoped=true&"
import script from "./AddProfilesAdminModal.vue?vue&type=script&lang=ts&"
export * from "./AddProfilesAdminModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddProfilesAdminModal.vue?vue&type=style&index=0&id=7b86b0f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b86b0f4",
  null
  
)

export default component.exports